import React, { useState, useRef, useEffect } from "react";
import NavbarBrandBox from "./NavbarBrandBox";
import NotificationDropdown from "./NotificationDropdown";
import { Link, useLocation } from "react-router-dom";
import ProfileDropdownn from "./ProfileDropdownn";
import LogoutButton from "./LogoutButton";
import { CartItem } from "types";
import { Dropdown } from "react-bootstrap";
import { useCart } from "./CartContext";
import { showError, showSuccess } from "toast/toast";
import { License } from "types";
import CartDropdown from "./cart/CartDropdown";

import { getAuthCookie } from "../utils/authCookies";
const RealtorHeader = () => {
  const userName = getAuthCookie("userName");
  const userType = getAuthCookie("userType");
  const token = getAuthCookie("sessionToken");
  const cartId = localStorage.getItem("cart_id");
  const [loading, setLoading] = useState(true);
  // const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const cartDropdownRef = useRef<HTMLDivElement>(null);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const userId = getAuthCookie("userId");
  const organizationId = getAuthCookie("organizationId");
  const [isActive, setIsActive] = useState(false);
  const [searchText, setSearchText] = useState("");
  const divRef = useRef<HTMLDivElement | null>(null);
  const { cartItems, fetchCart } = useCart();
  const [license, setLicense] = useState<License | null>(null);
  const [error, setError] = useState<string>("");
  const location = useLocation();

  useEffect(() => {
    fetchCart();
  }, []);

  // Re-fetch cart whenever the route changes (handles redirects after order placement)
  useEffect(() => {
    fetchCart();
  }, [location.pathname]);

  useEffect(() => {
    const fetchLicense = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/organizations/${organizationId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch license data");
        }

        const data = await response.json();
        // console.log("Fetched License Data:", data);
        if (data) {
          setLicense(data);
        }

      } catch (error) {
        console.error("Error fetching license data:", error);
        setError("Failed to fetch license data.");
      } finally {
        setLoading(false);
      }
    };

    if (!license) {
      fetchLicense();
    }
  }, [userId, license, token]);

  function toTitleCase(input: string): string {
    return input
      .split(" ") // Split the string into words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter
      .join(" "); // Join the words back into a string
  }

  // Fetch cart items on load
  // useEffect(() => {
  //   const fetchCartItems = async () => {
  //     try {
  //       setLoading(true);
  //       const response = await fetch(`${process.env.REACT_APP_API_URL}/carts/${cartId}`, {
  //         method: "GET",
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "application/json",
  //         },
  //       });

  //       if (!response.ok) throw new Error("Failed to fetch cart data");

  //       const data = await response.json();
  //       setCartItems(data.cart_items || []);
  //     } catch (err) {
  //       console.error("Error fetching cart data:", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   if (token && cartId) fetchCartItems();
  // }, [token, cartId]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        cartDropdownRef.current &&
        !cartDropdownRef.current.contains(event.target as Node)
      ) {
        setIsCartOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toogleMenuBtn = () => {
    setIsActive(!isActive);

    var windowSize = document.documentElement.clientWidth;
    const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;

    if (windowSize > 767) humberIcon.classList.toggle("open");

    //For collapse horizontal menu
    if (document.documentElement.getAttribute("data-layout") === "horizontal") {
      document.body.classList.contains("menu")
        ? document.body.classList.remove("menu")
        : document.body.classList.add("menu");
    }

    //Two column menu
    if (document.documentElement.getAttribute("data-layout") === "twocolumn") {
      document.body.classList.contains("twocolumn-panel")
        ? document.body.classList.remove("twocolumn-panel")
        : document.body.classList.add("twocolumn-panel");
    }
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (divRef.current && !divRef.current.contains(event.target as Node)) {
      setIsActive(false); // Hide the div
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleRemoveProduct = async (productId: string, variantId: string) => {
    try {
      setLoading(true);

      const token = getAuthCookie("sessionToken");
      const cartId = localStorage.getItem("cart_id");

      if (!token || !cartId) {
        console.error("Missing token or cartId");
        setLoading(false);
        return;
      }
      // console.log("productId :", productId)
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/carts/${cartId}/products/${productId}/variants/${variantId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to delete product");
      }

      await fetchCart(); // Refresh the cart items
      showSuccess("Product removed successfully!");
    } catch (err) {
      showError("Failed to remove product");
    } finally {
      setLoading(false);
    }
  };

  // Close on ESC (mobile only)
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (window.innerWidth <= 767 && e.key === "Escape") {
        document.body.classList.remove("vertical-sidebar-enable", "sidebar-enable");
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  // If viewport becomes tablet/desktop, ensure off-canvas is closed
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 768) {
        document.body.classList.remove("vertical-sidebar-enable", "sidebar-enable");
      }
    };
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);



  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex">
              <NavbarBrandBox />

              <button
                onClick={() => document.body.classList.add("vertical-sidebar-enable")}
                type="button"
                className="btn btn-sm px-3 fs-16 header-item d-inline-flex d-md-none material-shadow-none"
                aria-label="Open sidebar"
              >
                <i className="ri-menu-2-line"></i>
              </button>
            </div>

            <div className="d-flex align-items-center">
              <CartDropdown base="realtor" />

              {/* <NotificationDropdown /> */}
              <ProfileDropdownn name={userName || "Guest"} role={userType || "Brokerage firm"} imageUrl={license?.profilePic || ""}  login= {"realtor"} token={token ||""}/>
            </div>
          </div>
        </div>
      </header>
      {isActive && (
        <div ref={divRef} className="active">
          <div
            className={
              isActive
                ? "app-menu navbar-menu vertical-sidebar-enable"
                : "app-menu navbar-menu"
            }
          >
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src="./assets/images/logo-sm.png" alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src="/assets/images/logo-dark.png" alt="" height="17" />
                </span>
              </Link>
              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src="/assets/images/logo-sm.png" alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src="assets/images/logo-light.png" alt="" height="17" />
                </span>
              </Link>
              <button
                type="button"
                className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
                id="vertical-hover"
              >
                <i className="ri-record-circle-line"></i>
              </button>
            </div>

            <div className="dropdown sidebar-user m-1 rounded">
              <button
                type="button"
                className="btn material-shadow-none"
                id="page-header-user-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span className="d-flex align-items-center gap-2">
                  <img
                    className="rounded header-profile-user"
                    src="/assets/images/users/avatar-1.jpg"
                    alt="Header Avatar"
                  />
                  <span className="text-start">
                    <span className="d-block fw-medium sidebar-user-name-text">
                      Anna Adame
                    </span>
                    <span className="d-block fs-14 sidebar-user-name-sub-text">
                      <i className="ri ri-circle-fill fs-10 text-success align-baseline"></i>{" "}
                      <span className="align-middle">Online</span>
                    </span>
                  </span>
                </span>
              </button>
              <div className="dropdown-menu dropdown-menu-end">
                <Link className="dropdown-item" to="/realtor/profile">
                  <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>{" "}
                  <span className="align-middle">Profile</span>
                </Link>
                <LogoutButton />
              </div>
            </div>
            <div id="scrollbar">
              <div className="container-fluid">
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav">
                  <li className="nav-item">
                    <Link
                      className="nav-link menu-link"
                      to="/realtor/dashboard"
                      role="button"
                      aria-expanded="false"
                      aria-controls="sidebarDashboards"
                    >
                      <i className="ri-dashboard-2-line"></i>{" "}
                      <span data-key="t-dashboards">Dashboard </span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link menu-link"
                      to="/realtor/offices"
                      role="button"
                      aria-expanded="false"
                      aria-controls="sidebarDashboards"
                    >
                      <i className="ri-dashboard-2-line"></i>{" "}
                      <span data-key="t-dashboards">Offices </span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link menu-link"
                      to="/realtor/teammembers"
                      role="button"
                      aria-expanded="false"
                      aria-controls="sidebarDashboards"
                    >
                      <i className="ri-dashboard-2-line"></i>{" "}
                      <span data-key="t-dashboards">Team Members </span>
                    </Link>
                  </li>

                  <li className="nav-item">
                    <LogoutButton />
                  </li>
                </ul>
              </div>
            </div>
            <div className="sidebar-background"></div>
          </div>
        </div>
      )}
      {/* <div className="vertical-overlay"></div> */}
    </React.Fragment>
  );
};

export default RealtorHeader;
